<template>
  <div class="tab">
    <label :class="courseType==0?'active':'normal'">
      全部课程<input type="radio" name="ranking" v-model="courseType" value="0"/>
    </label>
    <label :class="courseType==1?'active':'normal'">
      当前课程<input type="radio" name="ranking" v-model="courseType" value="1"/>
    </label>
  </div>
</template>

<script>
export default {
  name: "mCourseTab",
  props: {
    currentType: {
      type: [Number, String],
      default: 1
    }
  },
  watch: {
    currentType: {
      handler(val) {
        this.courseType = val
      },
      immediate: true
    },
    courseType(val){
      this.$emit('change',val)
    }
  },
  data() {
    return {
      courseType: '1',
    }
  }
}
</script>

<style scoped lang="scss">
 .tab {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 40px;
  margin-top: 4%;
  z-index: 2;
  font-size: calc(0.13 * var(--fontSize));


  & > label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & > .active {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(1.14 * var(--fontSize));
    height: calc(0.37 * var(--fontSize));
    border-radius: calc(0.23 * var(--fontSize));
    background: #589FF8;
    border: 1px solid #FFFFFF;
    box-shadow: -7px -7px 20px 0px #FFFFFF, 7px 7px 20px 0px #DEDDE3, 5px 5px 5px #5095ec inset;
    color: white;
    text-shadow: 1px 1px 2px #0c468c;
    font-size: 14px;
    transition: .4s;
    cursor: default;
  }

  & > .normal {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(1.14 * var(--fontSize));
    height: calc(0.37 * var(--fontSize));
    border-radius: calc(0.23 * var(--fontSize));
    background: linear-gradient(180deg, #F3F5F7 0%, #F3F5F7 9.91%, #FEFEFF 100%);
    border: 1px solid #FFFFFF;
    box-shadow: -7px -7px 20px 0px #FFFFFF, 7px 7px 20px 0px #DEDDE3;
  }

  input {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mCourseTab.vue